module.exports = __webpack_public_path__ + "img/t-29028-032.6dc01fdc.jpg";